import {
    call,
    put,
    takeEvery,
    all
} from 'redux-saga/effects';
import * as actions from './actions';
import * as permissionsApi from '../api/permissionsApi';

export function* getUserPermissions(api) {
    try {
        const authorisedPermissions = yield call(
            api.fetchPermissions
        );
        yield put(actions.getUserPermissionsSuccess(authorisedPermissions));
    } catch (error) {
        yield put(actions.getUserPermissionsError(error.toString()));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(
            actions.GET_USER_PERMISSIONS_REQUEST,
            getUserPermissions, permissionsApi
        )
    ]);
}
